import { Badge } from '@/shared/ui/primitives'
import { cn } from '@/shared/ui/cn'

export type EntityStatusBadgeProps = {
  status: string
  className?: string
}

type StatusMeta = {
  dotClass: string
  variant: 'default' | 'secondary' | 'outline' | 'destructive' | 'success' | 'warning' | 'info'
}

const STATUS_META: Record<string, StatusMeta> = {
  active: { dotClass: 'bg-sage', variant: 'success' },
  reserved: { dotClass: 'bg-steel', variant: 'info' },
  maintenance: { dotClass: 'bg-amber', variant: 'warning' },
  seasonal: { dotClass: 'bg-amber', variant: 'warning' },
  out_of_service: { dotClass: 'bg-destructive', variant: 'destructive' },
  inactive: { dotClass: 'bg-muted-foreground', variant: 'outline' },
}

const FALLBACK_META: StatusMeta = { dotClass: 'bg-muted-foreground', variant: 'outline' }

function titleCase(value: string): string {
  return value
    .split('_')
    .map((part) => (part.length === 0 ? part : part[0].toUpperCase() + part.slice(1)))
    .join(' ')
}

export function EntityStatusBadge({ status, className }: EntityStatusBadgeProps) {
  const meta = STATUS_META[status] ?? FALLBACK_META
  return (
    <Badge variant={meta.variant} className={cn('gap-1.5', className)}>
      <span aria-hidden className={cn('size-2 rounded-full', meta.dotClass)} />
      {titleCase(status)}
    </Badge>
  )
}
